import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { TestComponent } from './test/test.component';
import { ExamComponent } from './exam/exam.component';

const routes: Routes = [
  {    
    path: '',
    pathMatch: 'prefix',
    //component: TestComponent,
    // canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    children: [
      //{ path:'test', data: { breadcrumb: 'Ana Sayfa', roles: ['STUDENT'] }, component:TestComponent },
      { path:'exam/:id/:bookletindex', data: { breadcrumb: 'Deneme', roles: ['STUDENT'] }, component: ExamComponent },
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExamRoutingModule { }
